module.exports = __webpack_public_path__ + "media/images/icons/info-60dcea22ca3b60ffce8c1f9332f41b58.svg";